import React, {HTMLAttributes} from 'react';
import {useAuthStore} from '@/store/auth_store';
import {NotificationLink} from '@/components/pages/notifications/links/NotificationLink';
import PermissionsHelpers from '@/helpers/permissions_helpers';
import {parseNotificationMetadata} from "@/api/dto/notification";
import {Feature, FeatureNew, FeaturePermissionLevel} from "@/api/dto/permissions";
import {FeatureToggle, Roster} from "@/api/dto/dto";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";

type Props = HTMLAttributes<HTMLAnchorElement> & {
  metadata?: string;
  roster?: Roster;
};

export default function TaskLink({ metadata, roster: currentRoster, ...props }: Props) {
  const { currentUser } = useAuthStore();
  const {checkBooleanToggle} = useFeatureToggles();

  const isNewPermissionsEnabled = checkBooleanToggle(FeatureToggle.CARECO_3415_NEW_USER_PERMISSIONS);

  const notificationMetadata = parseNotificationMetadata(metadata);

  return currentRoster && (isNewPermissionsEnabled ?
    PermissionsHelpers.canForUserFeaturePermissionRosterNew(
      currentUser!,
      currentRoster,
      FeaturePermissionLevel.VIEW,
      FeatureNew.TASKS
    ) : PermissionsHelpers.canForUserFeaturePermissionRoster(
      currentUser!,
      currentRoster,
      FeaturePermissionLevel.VIEW,
      Feature.TASKS
    )) ? (
      <NotificationLink to={`/${notificationMetadata.urlSuffix}`} {...props}>
        {notificationMetadata.message}
      </NotificationLink>
    ) : (
      <>{notificationMetadata.message}</>
    );
}
